import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import MapResults from "./MapResults";
import ResultSideBody from "./restaurantResults/ResultSideBody";
import Breadcrumb from "../common/Breadcrumb";
import ViewToggle from "../common/ViewToggle";
import EventOverviewPanel from "./events/EventOverviewPanel";
import useEvent from "../../hooks/useEvent";

const overviewWrapperStyle = { flex: "1 1 auto" };

const EventPage = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { event, loading, error } = useEvent();
  const view = searchParams.get("view") === "overview" ? "overview" : "map";

  const isEmbed = location.pathname.endsWith("/embed");

  if (loading && !event) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <i className="fas fa-spinner fa-spin fa-2x" />
      </div>
    );
  }

  if (error || !event) {
    return null;
  }

  const hasEnded = !!(event.endDate && new Date(event.endDate) < new Date());

  const title = `${event.name} | VegifyIt`;
  const description = event.description
    ? `Discover vegan-friendly dishes at ${event.name}! ${event.description}`
    : `Discover vegan-friendly dishes at ${event.name}!`;

  const overviewHidden = view !== "overview";
  const mapHidden = view !== "map";

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Event",
            name: event.name,
            description:
              event.description ||
              `Discover vegan-friendly dishes at ${event.name}!`,
            startDate: event.startDate,
            endDate: event.endDate,
            location: {
              "@type": "Place",
              geo: {
                "@type": "GeoCoordinates",
                latitude: event.lat,
                longitude: event.lng,
              },
            },
          })}
        </script>
      </Helmet>
      {!isEmbed && (
        <Breadcrumb
          items={[
            { label: "Events", href: "/events" },
            { label: event.name },
          ]}
          rightSlot={<ViewToggle />}
        />
      )}
      {!isEmbed && (
        <div
          style={overviewHidden ? { display: "none" } : overviewWrapperStyle}
        >
          <EventOverviewPanel event={event} hasEnded={hasEnded} />
        </div>
      )}
      <div
        className={
          !isEmbed && mapHidden
            ? "main-app-stash"
            : `main-app${!isEmbed ? " main-app--with-breadcrumb" : ""}`
        }
        style={!isEmbed && mapHidden ? { display: "none" } : undefined}
      >
        <MapResults isMarkerShown />
        <ResultSideBody />
      </div>
    </>
  );
};

export default EventPage;
